import { ApiProperty } from '@nestjs/swagger';
import { UserRoleInterface } from '../interfaces/user-role.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';

export class UserRoleDto extends CommonEntityDto implements UserRoleInterface {
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  userId!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  roleId!: string;
}
